/**
 * InvoiceFilters Component
 * Status filter pills + text search for invoice modals
 */

import './InvoiceFilters.css';

const STATUS_OPTIONS = ['All', 'AUTHORISED', 'PAID', 'DRAFT'] as const;

interface InvoiceFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (status: string) => void;
  totalCount: number;
  filteredCount: number;
}

export function InvoiceFilters({
  searchText,
  onSearchChange,
  statusFilter,
  onStatusChange,
  totalCount,
  filteredCount,
}: InvoiceFiltersProps) {
  return (
    <div className="invoice-filters">
      <div className="invoice-filters__search">
        <input
          type="text"
          className="invoice-filters__input"
          placeholder="Search invoice # or client..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search invoices"
        />
        {searchText && (
          <button
            className="invoice-filters__clear"
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
          >
            &times;
          </button>
        )}
      </div>
      <div className="invoice-filters__pills">
        {STATUS_OPTIONS.map((status) => (
          <button
            key={status}
            className={`invoice-filters__pill${
              statusFilter === status ? ' invoice-filters__pill--active' : ''
            }`}
            onClick={() => onStatusChange(status)}
            aria-pressed={statusFilter === status}
          >
            {status === 'All' ? 'All' : status.charAt(0) + status.slice(1).toLowerCase()}
          </button>
        ))}
      </div>
      {filteredCount !== totalCount && (
        <span className="invoice-filters__count">
          Showing {filteredCount} of {totalCount}
        </span>
      )}
    </div>
  );
}
